import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Admin.css";
import api from "../utils/api.utils";
import { FooterAdmin } from "../components/FooterAdmin";
import { NavbarAdmin } from "../components/NavbarAdmin";

export const AllCategory = ({ loading, setLoading }) => {
  const [denuncias, setDenuncias] = useState([]);

  useEffect(() => {
    const getOuvidorias = async () => {
      try {
        const data = await api.getDenuncias();
        setDenuncias(data);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } catch (error) {
        console.log(error, "Error to get Ouvidorias");
      }
    };
    getOuvidorias();
  }, [loading, setLoading]);






  let totalAssedioMoral,
    totalAssedioSexual,
    totalDiscriminacao,
    totalGestaoInadequada,
    totalRelacionamentos;

  totalAssedioMoral =
    totalAssedioSexual =
    totalDiscriminacao =
    totalGestaoInadequada =
    totalRelacionamentos =
      0;

  let totalFraudes,
    totalCorrupcao,
    totalConflitos,
    totalAtividades,
    totalFraudesCorrupcao;

  totalFraudes =
    totalCorrupcao =
    totalConflitos =
    totalAtividades =
    totalFraudesCorrupcao =
      0;

  let totalSaude, totalSaudeSeguranca;

  totalSaude = totalSaudeSeguranca = 0;

  denuncias?.forEach((denuncia) => {
    if (denuncia.category === "assedio-moral" && denuncia.status !== 'pendente') {
      return totalAssedioMoral++;
    }
    if (denuncia.category === "assedio-sexual") {
      return totalAssedioSexual++;
    }
    if (denuncia.category === "discrimanacao") {
      return totalDiscriminacao++;
    }
    if (denuncia.category === "gestao-inadequada") {
      return totalGestaoInadequada++;
    }

    if (denuncia.category === "fraude") {
      return totalFraudes++;
    }
    if (denuncia.category === "corrupcao") {
      return totalCorrupcao++;
    }
    if (denuncia.category === "conflito-interesse") {
      return totalConflitos++;
    }
    if (denuncia.category === "atividades-ilicitas") {
      return totalAtividades++;
    }

    if (denuncia.category === "riscos-operacionais") {
      return totalSaude++;
    }
    
    
  });


  totalRelacionamentos =
    totalAssedioMoral +
    totalAssedioSexual +
    totalDiscriminacao +
    totalGestaoInadequada

  totalFraudesCorrupcao =
    totalFraudes + totalConflitos + totalCorrupcao + totalAtividades;

  totalSaudeSeguranca = totalSaude;


  let totalTotal = totalRelacionamentos + totalFraudesCorrupcao + totalSaudeSeguranca

 

  return !loading ? (
    <div className="admin-home">
      <NavbarAdmin />
      <div className="d-flex flex-column align-items-center mt-3">
        <h5> Total de denúncias: {totalTotal}</h5>
      </div>
      <hr />
      <section className="d-flex  justify-content-center">
        <div className="d-flex container flex-wrap row">
          <h6>Relacionamentos: {totalRelacionamentos}</h6>
          <Link
            to="/admin/tipo/assedio-moral/"
            className="col-sm-12 col-md-4 col-lg-3 mt-3"
          >
            <div className="card-body">
              <p className="number-stat">{totalAssedioMoral}</p>
              <p className="p">Assédio Moral</p>
            </div>
          </Link>
          <Link
            to="/admin/tipo/assedio-sexual/"
            className="col-sm-12 col-md-4 col-lg-3 mt-3"
          >
            <div className="card-body">
              <p className="number-stat">{totalAssedioSexual}</p>
              <p className="p">Assédio Sexual</p>
            </div>
          </Link>
          <Link
            to="/admin/tipo/gestao-inadequada/"
            className="col-sm-12 col-md-4 col-lg-3 mt-3"
          >
            <div className="card-body">
              <p className="number-stat">{totalGestaoInadequada}</p>
              <p className="p">Gestão Inadequada</p>
            </div>
          </Link>{" "}
          <Link
            to="/admin/tipo/discriminacao/"
            className="col-sm-12 col-md-4 col-lg-3 mt-3"
          >
            <div className="card-body">
              <p className="number-stat">{totalDiscriminacao}</p>
              <p className="p">Discriminação</p>
            </div>
          </Link>
        </div>
      </section>
      <hr className="" />
      <section className="d-flex  justify-content-center">
        <div className="d-flex container flex-wrap row">
          <h6>
            Fraudes, Corrupção e Atividades ilícitas: {totalFraudesCorrupcao}
          </h6>
          <Link
            to="/admin/tipo/fraude/"
            className="col-sm-12 col-md-4 col-lg-3 mt-3"
          >
            <div className="card-body">
              <p className="number-stat">{totalFraudes}</p>
              <p className="p">Fraude</p>
            </div>
          </Link>
          <Link
            to="/admin/tipo/corrupcao/"
            className="col-sm-12 col-md-4 col-lg-3 mt-3"
          >
            <div className="card-body">
              <p className="number-stat">{totalCorrupcao}</p>
              <p className="p">Corrupção</p>
            </div>
          </Link>
          <Link
            to="/admin/tipo/conflito-interesse/"
            className="col-sm-12 col-md-4 col-lg-3 mt-3"
          >
            <div className="card-body">
              <p className="number-stat">{totalConflitos}</p>
              <p className="p">Conflitos de Interesses</p>
            </div>
          </Link>{" "}
          <Link
            to="/admin/tipo/atividades-ilicitas/"
            className="col-sm-12 col-md-4 col-lg-3 mt-3"
          >
            <div className="card-body">
              <p className="number-stat">{totalAtividades}</p>
              <p className="p">Atividades Ilícitas</p>
            </div>
          </Link>
        </div>
      </section>
      <hr className="" />
      <section className="d-flex  justify-content-center">
        <div className="d-flex container flex-wrap row">
          <h6>Saúde e Segurança Ocupacional: {totalSaudeSeguranca}</h6>
          <Link
            to="/admin/tipo/riscos-operacionais/"
            className="col-sm-12 col-md-4 col-lg-3 mt-3"
          >
            <div className="card-body">
              <p className="number-stat">{totalSaude}</p>
              <p className="p">Saúde e Segurança Ocupacional</p>
            </div>
          </Link>
        </div>
      </section>

      <FooterAdmin />
    </div>
  ) : (
    <>Loading...</>
  );
};
